// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AvatarUsuarioLog__avatarUsu__24bLI {\r\n  background-color: orange;\r\n}\r\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatarUsu": "AvatarUsuarioLog__avatarUsu__24bLI"
};
export default ___CSS_LOADER_EXPORT___;
